export function globalPrivacyControlEnabled(navigatorLike: unknown = globalThis.navigator): boolean {
  if (!navigatorLike || typeof navigatorLike !== "object") return false;
  return (navigatorLike as { globalPrivacyControl?: boolean }).globalPrivacyControl === true;
}
